import makeStyles from 'd2/hooks/tss/makeStyles'
import tinycolor from 'tinycolor2'
import type { MergedThemes } from 'd2/types'

const styles = (theme: MergedThemes) => ({
  disabled: {
    backgroundColor: tinycolor(theme.colors.darkerGray)
      .lighten(10)
      .toHexString(),
  },
  lightBorder: {
    border: `1px solid ${theme.colors.darkerGray}`,
  },
} as const)

export default makeStyles({
  name: 'Box',
})(styles)
